exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".total-amount[data-v-76aa34e1]{color:#545e72;font-family:San Francisco Display Bold;font-size:24px;text-transform:uppercase}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/calendar/ListPrepayment.vue"],"names":[],"mappings":"AACA,+BACE,cAAe,AACf,uCAA0C,AAC1C,eAAgB,AAChB,wBAA0B,CAC3B","file":"ListPrepayment.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.total-amount[data-v-76aa34e1] {\n  color: #545e72;\n  font-family: \"San Francisco Display Bold\";\n  font-size: 24px;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76aa34e1","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["/opt/build/repo/src/stylesheets/fonts.scss","/opt/build/repo/src/stylesheets/variables.scss","/opt/build/repo/src/stylesheets/mixins.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/clerkinn/calendar/ListPrepayment.vue
// module id = 1427
// module chunks = 26